// extracted by mini-css-extract-plugin
export default {"container":"SnackbarMessage_container__6PLdG","fadeOut":"SnackbarMessage_fadeOut__givuF"};